import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconOverlayStack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M2.667 4.253c0-.876.71-1.586 1.586-1.586h14.351c.876 0 1.586.71 1.586 1.586v1.459H8.825a3.113 3.113 0 0 0-3.113 3.113V20.19H4.253c-.876 0-1.586-.71-1.586-1.586V4.253zm6.158 2.986h14.351c.876 0 1.586.71 1.586 1.586v1.459H13.397a3.036 3.036 0 0 0-.922.139 3.117 3.117 0 0 0-2.19 2.974v11.365H8.826c-.876 0-1.586-.71-1.586-1.586V8.825c0-.876.71-1.586 1.586-1.586zm2.986 17.522v2.986c0 .876.71 1.586 1.586 1.586h14.351c.876 0 1.586-.71 1.586-1.586V13.396c0-.876-.71-1.586-1.586-1.586H13.397a1.587 1.587 0 0 0-1.586 1.586v11.365z"
	})
});
export { SvgIconOverlayStack as ReactComponent };
